<template>
	<div class="communication">
		<div class="communicationCon">
			<div class="conversationList">
				<template v-if="allConversation.length==0||!sdkReady">
					<no-Data :text="sdkReady?'暂无7天内消息记录':'登录后查看消息'"></no-Data>
				</template>	
				<template v-else>
					<div v-for="(item,index) of allConversation" :key="index" class="li" :class="{'select':item.conversationID==currentConversationID}"  @click="toChat(item.conversationID)">
						<div class="avatarbox">
							<el-image class="avatar" :src="item.userProfile.avatar||require('@/static/avatar.png')"  fit="cover"></el-image>
							<div v-if="item.unreadCount>0" class="unreadCount">
								{{item.unreadCount>99?'99+':item.unreadCount}}
							</div>
						</div>	
						<div class="info">
							<div class="top">
								<div class="time">
									{{formatCustomTime(item.lastMessage.lastTime?item.lastMessage.lastTime*1000:null)}}
								</div>
								<div class="topL">
									<span style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;">
										<span class="name">{{item.userProfile.nick.split('&')[0]}}</span>
										<span class="cor" v-if="item.userProfile.nick.split('&')[1]">{{item.userProfile.nick.split('&')[1]}}</span>
									</span>
								</div>
							</div>
							<div class="mess">
								<template v-if="item.lastMessage.isRevoked">
									{{item.lastMessage.fromAccount==userinfo.en_im_account||item.lastMessage.fromAccount==userinfo.en_im_accountuser_im_account?'你':'对方'}}
									撤回一条消息
								</template>
								<template v-else-if="item.lastMessage.type!= 'TIMCustomElem'">{{ item.lastMessage.messageForShow||'正在沟通中'}}</template>
								<template v-else>
									<span v-if="item.lastMessage.payload.description=='pushJob'">[职位信息]</span>
									<span v-if="item.lastMessage.payload.description=='deliverJob'">[投递职位]</span>
									<span v-if="item.lastMessage.payload.description=='firstMsg'">
										{{item.lastMessage.fromAccount==userinfo.en_im_account||item.lastMessage.fromAccount==userinfo.en_im_accountuser_im_account?'由你':'对方'}}发起沟通
									</span>
								</template>
							</div>
						</div>
					</div>
				</template>
			</div>
			
			<div class="chatFrame" :class="{'whiteback':Object.keys(currentConversation).length==0}">
				<template v-if="allConversation.length==0||!sdkReady">
					<no-Data :text="sdkReady?'暂无7天内消息记录':'登录后查看消息'"></no-Data>
				</template>
				<template v-else>
					<template v-if="Object.keys(currentConversation).length==0">
						<no-Data height text="近期进行过的沟通会在左侧列表中显示"></no-Data>
					</template>
					<template v-else-if="chatUserinfo">
						<div class="chatHistory">
							<div class="info">
								<div class="name" :style="{'cursor':$store.state.standing=='company'?'pointer':''}" @click="toUser(toAccount)"> {{chatUserinfo.nick.split('&')[0]}} </div>
								<div class="corName" v-if="chatUserinfo.nick.split('&')[1]"> {{chatUserinfo.nick.split('&')[1]}} </div>
							</div>
							<div class="position" v-if="positionDetail" :class="{'filter':positionDetail.status==1}">
								<div class="title" @click="openPosition()"> {{positionDetail.position_name}} </div>
								<div class="pay" @click="openPosition()">
									<template v-if="positionDetail.status==1">
										暂停招聘
									</template>
									<template v-else>
										<span v-if="positionDetail.type=='2'">{{positionDetail.salary_part_time_job}}</span>
										<span v-else>{{`${parseFloat((positionDetail.salary_min/1000).toFixed(1))}-${parseFloat((positionDetail.salary_max/1000).toFixed(1))}k`}}</span>
									</template>
								</div>
								<div class="address" @click="openPosition()">{{positionDetail.address.split('-')[1]}}</div>
							</div>
							<div class="history" ref="historybox" v-show="!dataShow" v-loading="dataLoading">
								<div v-for="(item,index) in currentMessageList" :key='index'>
									<div class="list" v-if="!item.isDeleted&&!(item.type=='TIMCustomElem'&&(item.payload.description=='firstMsg'))" :id="`C2C${item.ID}`" :class="item.from==toAccount?'left':'right'">
										<div class="avatarbox" @click="toUser(item.from)" :style="{'cursor':item.from==toAccount&&item.from.includes('User')&&$store.state.standing=='company'?'pointer':''}">
											<el-image class="avatar" :src="item.avatar||require('@/static/avatar.png')"  fit="cover"></el-image>
										</div>
										<div class="msgbox">
											<div class="text" v-if="item.type == 'TIMTextElem'" @longpress="longpress($event,item,(item.from==toAccount),index)">{{item.payload.text}}</div>
											<div class="imgbox" v-if="item.type == 'TIMImageElem'" @longpress="longpress($event,item,(item.from==toAccount),index)">
												<el-image class="img" :src="item.payload.imageInfoArray[0].url" :preview-src-list="[item.payload.imageInfoArray[0].url]" fit="cover"></el-image>
											</div>
											<div class="audio play" v-if="item.type == 'TIMSoundElem'" @click="playAudio(item)">
												<audioIcon :color="item.from==toAccount?'#333333':'#FFFFFF'" :animation="playAudioId==item.ID&&audioStatus" :transform="item.from!=toAccount" :seconds="item.payload.second"></audioIcon>
											</div>
											<div class="locationBox" v-if="item.type=='TIMLocationElem'" @click="openTMap(item.payload.latitude,item.payload.longitude,item.payload.description)">
												<i class="icon el-icon-map-location"></i>
												<div class="locationtext">
													<template v-if="item.payload.description.indexOf('{')!=-1">
														<div class="locationtext">{{JSON.parse(item.payload.description).name}}</div>
														<div class="locationtext" style="font-size: 12px;margin-top: 3px;">{{JSON.parse(item.payload.description).address}}</div>
													</template>
													<div class="locationtext" v-else>{{item.payload.description}}</div>
												</div>
											</div>
											<div class="jobBox" v-if="item.type=='TIMCustomElem'&&(item.payload.description=='pushJob')" @click="toJob(item.payload.data)"  @longpress="longpress($event,item,(item.from==toAccount),index)">
												<div class="titlebox">
													<div class="name">{{JSON.parse(item.payload.data).title}}</div>
													<div class="price" v-if="parseFloat(JSON.parse(item.payload.data).salary_type==1)">{{`${parseFloat(JSON.parse(item.payload.data).salary_start)}/小时`}}</div>
													<div class="price" v-if="parseFloat(JSON.parse(item.payload.data).salary_type==2)">{{`${parseFloat(JSON.parse(item.payload.data).salary_start)}-${parseFloat(JSON.parse(item.payload.data).salary_end)}/月`}}</div>
													<div class="price" v-if="parseFloat(JSON.parse(item.payload.data).salary_type==3)">面议</div>
												</div>
												<div class="textbox">
													<div class="info">{{JSON.parse(item.payload.data).requirement}}</div>
													<div class="info">{{JSON.parse(item.payload.data).company}}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="history databox" v-show="dataShow">
								<div class="dataTitle">
									{{is_resume?'用户简历':'职位详情'}}
									<i class="el-icon-close" style="cursor:pointer;" @click="dataShow=false"></i>
								</div>
								<div class="infobox" v-if="userResume&&is_resume">
									<div class="userinfobox">
										<div class="avatarbox">
											<el-image class="avatar" :src="userResume.avatar||require('@/static/avatar.png')" fit="cover"></el-image>
										</div>
										<div class="textbox">
											<div class="name">{{userResume.user_name}} <span v-if="userResume.position_type">{{userResume.position_type}}</span></div>
											<div class="text">
												{{userResume.work_year}} · {{userResume.qualifications}} · {{userResume.ages?userResume.ages+'岁':'年龄未知'}}
											</div>
										</div>
									</div>
									<div class="evaluationbox" v-if="userResume.personal_evaluation">{{userResume.personal_evaluation}}</div>
									<div class="formbox">
										<div class="label">工作经历</div>
										<div class="explist">
											<div class="nodata" v-if="userResume.work.length==0">未填写工作经历</div>
											<div class="list" v-for="item in userResume.work" :key="item.id">
												<el-card body-style="padding:8px">
												    <div class="topbox">
												    	<div class="left">{{item.belong_to}}</div>
												    	<div class="right">{{item.start_time}}至{{item.end_time}}</div>
												    </div>
												    <div class="textbox">
												    	工作岗位：{{item.position}}
												    </div>
												    <div class="textbox">
												    	工作内容：{{item.descrption}}
												    </div>
												    <div class="textbox" v-if="item.remark">
												    	离职原因：{{item.remark}}
												    </div>
												</el-card>
											</div>
										</div>
									</div>
									<div class="formbox">
										<div class="label">项目经历</div>
										<div class="explist">
											<div class="nodata" v-if="userResume.project.length==0">未填写工作经历</div>
											<div class="list" v-for="item in userResume.project" :key="item.id">
												<el-card body-style="padding:8px">
												    <div class="topbox">
												    	<div class="left">{{item.belong_to}}</div>
												    	<div class="right">{{item.start_time}}至{{item.end_time}}</div>
												    </div>
												    <div class="textbox">
												    	担当职位：{{item.position}}
												    </div>
												    <div class="textbox">
												    	项目描述：{{item.descrption}}
												    </div>
												    <div class="textbox" v-if="item.remark">
												    	备注：{{item.remark}}
												    </div>
												</el-card>
											</div>
										</div>
									</div>
									<div class="formbox">
										<div class="label">教育经历</div>
										<div class="explist">
											<div class="nodata" v-if="userResume.education.length==0">未填写工作经历</div>
											<div class="list" v-for="item in userResume.education" :key="item.id">
												<el-card body-style="padding:8px">
												    <div class="topbox">
												    	<div class="left">{{item.belong_to}}</div>
												    	<div class="right">{{item.start_time}}至{{item.end_time}}</div>
												    </div>
												    <div class="textbox">
												    	就读专业：{{item.position}}
												    </div>
												    <div class="textbox" v-if="item.descrption">
												    	获奖概况：{{item.descrption}}
												    </div>
												    <div class="textbox" v-if="item.remark">
												    	备注：{{item.remark}}
												    </div>
												</el-card>
											</div>
										</div>
									</div>
								</div>
								<div class="positionbox" v-if="positionDetail&&!is_resume">
									<div class="tagbox" v-if="positionDetail.tag_name_others">
										<el-tag class="tag" v-for="(tag,index) of positionDetail.tag_name_others.split(',')" :key="index">{{tag}}</el-tag>
									</div>
									<div class="formbox" v-if="positionDetail.position_welfare_policy">
										<div class="label">福利政策</div>
										<div class="descbox">{{positionDetail.position_welfare_policy}}</div>
									</div>
									<div class="formbox" v-if="positionDetail.position_description">
										<div class="label">职位描述</div>
										<div class="descbox">{{positionDetail.position_description}}</div>
									</div>
									<div class="formbox" v-if="positionDetail.job_responsibilities">
										<div class="label">工作职责</div>
										<div class="descbox">{{positionDetail.job_responsibilities}}</div>
									</div>
									<div class="formbox" v-if="positionDetail.position_requirement">
										<div class="label">招聘要求</div>
										<div class="descbox">{{positionDetail.position_requirement}}</div>
									</div>
									<div class="formbox" v-if="positionDetail.work_time">
										<div class="label">工作时间</div>
										<div class="descbox">{{positionDetail.work_time}}</div>
									</div>
									<div class="formbox">
										<div class="label">工作地址</div>
										<div class="descbox">{{positionDetail.address}} {{positionDetail.address_details?positionDetail.address_details:''}}</div>
									</div>
									<div class="formbox" v-if="positionDetail.company">
										<div class="label">招聘企业</div>
										<div class="descbox">{{positionDetail.company.company_name}} <span class="companyName" @click="toCompany(positionDetail.company.id)">查看详情{{'\n'}}</span>企业规模：{{positionDetail.company.person_count+'\n'}}企业地址：{{positionDetail.company.company_address}}{{positionDetail.company.address_detail}}
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="chatInput">
							<div class="menubox">
								<el-popover
									placement="top-start"
									width="400"
									trigger="click">
									<div class="usedBox">
										<div class="titlebox">
											<div>常用语</div>
											<div class="btn" @click="msgShow=true">设置</div>
										</div>
										<div class="listbox" v-if="msgList.length==0">
											<div class="nodata">尚未设置常用语，<span @click="msgShow=true">前往设置</span></div> 
										</div>
										<div class="listbox" v-for="(item,index) in msgList" :key="index" @click="setInput(item.content,1)">
											<div class="box">
												<div class="textbox">
													<div class="text">{{item.content}}</div>
													<div class="btn" @click.stop="setInput(item.content)">发送</div>
												</div>
											</div>
										</div>
									</div>
									<div slot="reference" class="iconbox">
										<i class="icon el-icon-chat-dot-square"></i>
										<span>常用语</span>
									</div>
								</el-popover>
								<div class="iconbox" @click="$refs.uploadImg.click()">
									<i class="icon el-icon-picture-outline"></i>
									<span>发送图片</span>
									<input class="uploadInput" id="uploadImg" ref="uploadImg" accept="image/*" type="file" :multiple="false" @change="chooseImage"/>
								</div>
								<div class="iconbox" @click="openChooseLocation">
									<i class="icon el-icon-place"></i>
									<span>发送位置</span>
								</div>
								<div class="iconbox" v-if="$store.state.standing=='company'" @click="toUser(toAccount)">
									<i class="icon el-icon-tickets"></i>
									<span>用户简历</span>
								</div>
								
							</div>
							<textarea 
								class="inputArea" 
								v-model="message"
								@keydown.alt.s.prevent="sendMsg(1)"
								@keydown.enter.prevent="handleEnterKey">
							</textarea>
							<div class="btnbox">
								按Enter键发送，按Ctrl+Enter键换行
								<el-button style="margin-left: 12px;" size="small" type="primary" @click="sendMsg(1)">发送消息</el-button>
							</div>
						</div>
					</template>
				</template>
				
			</div>
		</div>
		
		<!-- 查看位置 -->
		<div class="mapBody" :class="{'mapShow':mapShow}" @click="mapShow = false">
			<div class="mapbox" @click.stop="">
				<div class="titlebox">
					<div class="bold">位置信息</div>
					<i class="icon el-icon-close" @click="mapShow = false"></i>
				</div>
				<div id="TMap" style="width: 600px;height: 400px;"></div>
			</div>
		</div>
		
		<!-- 选择位置 -->
		<div class="mapBody" :class="{'mapShow':chooseShow}" @click="chooseShow = false">
			<div class="mapbox" @click.stop="">
				<div class="titlebox">
					<div class="bold">发送位置</div>
					<i class="icon el-icon-close" @click="chooseShow = false"></i>
				</div>
				<chooseLocation @pickAddress="pickAddress($event)"></chooseLocation>
				<div style="margin-top: 12px;display: flex;justify-content: center;align-items: center;">
				    <el-button @click="chooseShow = false">取消</el-button>
				    <el-button type="primary" @click="confirmChoose()">发送位置</el-button>
				</div>
			</div>
		</div>
	
		<!-- 快捷回复 -->
		<el-dialog
			title="常用语设置"
			:visible.sync="msgShow"
			width="600px">
			<div class="setMsgBox">
				<div class="listbox" v-loading="msgLoading">
					<div class="nodata" v-if="msgList.length==0">尚未设置常用语</div>
					<div class="list" v-for="(item,index) in msgList" :key="index">
						<div class="text">{{item.content}}</div>
						<div class="delIcon" @click="delMsg(item.id)"><i class="el-icon-error"></i></div>
					</div>
				</div>
				<div class="btnbox" v-if="msgList.length<10">
					<el-button type="primary" size="small" @click="addMsg">+添加一条</el-button>
					<div class="tips">（最多添加十条）</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let that;
	import { mapState,mapGetters } from 'vuex';
	import {formatCustomTime} from '@/unit/util.js'
	import AMapLoader from "@amap/amap-jsapi-loader";
	export default {
		name: 'communication',
		data() {
			return {
				mapKey:'7982d53ea52e1e06d5dc038f112b3be2',
				formatCustomTime:formatCustomTime,
				chatUserinfo:null,
				positionId:'',
				positionDetail:null,
				playAudioId:'',
				audioStatus:false,
				AUDIO:null,
				mapShow:false,
				mapContent:null,
				mapMarker:null,
				chooseShow:false,
				chooseLocation:null,
				msgList:[],
				msgShow:false,
				msgLoading:false,
				message:'',
				dataShow:false,
				dataLoading:false,
				userResume:null,
				is_resume:false,
			}
		},
		created() {
			that = this;
			if(this.toAccount){
				this.tim.getUserProfile({userIDList:[this.toAccount]}).then(res=>{
					this.chatUserinfo = res.data[0]
					this.$nextTick(()=>{
						const historybox = this.$refs.historybox
						historybox.scrollTo({top:historybox.scrollHeight})
					})
				})
			}
			if(this.storePositionId){
				this.positionId = this.storePositionId;
				this.getPosition()
			}
			this.getMsgList()
		},
		beforeDestroy() {
			this.$store.commit('resetCurrentConversation')
			if(this.mapContent) this.mapContent.destroy();
		},
		computed: {
			...mapGetters({
				toAccount: 'toAccount',
			}),
			...mapState({
				storePositionId: state => state.conversation.positionId,
				currentConversation: state => state.conversation.currentConversation,
				currentConversationID: state => state.conversation.currentConversationID,
				currentMessageList: state => state.conversation.currentMessageList,
				allConversation: state => state.conversation.allConversation,
				userinfo:state=>state.userinfo,
				sdkReady: state=>state.sdk_ready,
			})
		},
		mounted() {
			console.log('allConversation-------',this.allConversation)
			this.initMap()
		},
		watch:{
			'currentMessageList':(val)=>{
				console.log('currentMessageList-------',val)
				if (val.length !== 0) {
					if(!that.positionId&&val[val.length-1].cloudCustomData){
						that.positionId = val[val.length-1].cloudCustomData
						that.getPosition()
					}
					that.$nextTick(()=>{
						const historybox = that.$refs.historybox
						historybox.scrollTo({top:historybox.scrollHeight})
					})
				}
			},
		},
		methods: {
			toCompany(id){
				this.$router.push({ name: 'companyDe',query: {id:id } });
			},
			openPosition(){
				if(this.positionDetail.status==1) return;
				console.log(this.positionDetail)
				this.is_resume = false
				this.dataShow = true
			},
			toUser(from){
				if(from!=this.toAccount||(this.dataShow&&this.is_resume)) return;
				if(this.is_resume&&this.userResume) return this.dataShow = true;
				if(from.includes('User')&&this.$store.state.standing=='company'){
					this.dataLoading = true
					this.$axios.get('/api/client/ES/talentPoolDetails',{params:{user_im_account:from}}).then(res=>{
						this.dataLoading = false
						if(res.code==200){
							this.userResume = res.data
							this.is_resume = true
							this.dataShow = true
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}
			},
			handleEnterKey(event) {
			      if (event.ctrlKey) {
			        // Ctrl+Enter，执行换行操作
			        this.message += "\n";
			      } else {
			        // Enter，执行发送消息操作
			        this.sendMsg(1)
			      }
			},
			openChooseLocation(){
				this.chooseLocation = ''
				this.chooseShow = true
			},
			confirmChoose(){
				if(!this.chooseLocation) return this.$eltips('请搜索并选择地址','error')
				let option = {
					name:this.chooseLocation.name,
					address:this.chooseLocation.adname+this.chooseLocation.address,
					lat:this.chooseLocation.location.lat,
					lng:this.chooseLocation.location.lng,
				}
				this.sendMsg(3,option)
				this.chooseShow = false
			},
			pickAddress(e){
				this.chooseLocation = e
			},
			//选择图片
			chooseImage(e){
				const imgsFiles = e.target.files[0]
				if(!imgsFiles.type.startsWith('image/')) return this.$eltips('仅支持图片格式','error'),this.$refs['uploadImg'].value = '';
				this.sendMsg(2,imgsFiles)
				this.$refs['uploadImg'].value = '' 
			},
			getMsgList(){
				this.msgLoading = true
				this.$axios.get('/api/client/Common/getCommonPhrases').then(res=>{
					this.msgLoading = false
					if(res.code==200){
						this.msgList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			delMsg(id){
				this.$confirm('删除此消息后不可回复, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('/api/client/Common/deleteCommonPhrases',{id:id}).then(res=>{
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.getMsgList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			addMsg(){
				this.$prompt('请输入内容', '添加常用语', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValidator(value){
						if(!value) return '内容不能为空'
						if(value.replace(/\s/g,'').length<1) return '内容不能为空'
					},
					inputErrorMessage: '内容不能为空'
				}).then(({ value }) => {
					this.$axios.post('/api/client/Common/createCommonPhrases',{content:value}).then(res=>{
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.getMsgList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			setInput(e,type){
				if(type==1){
					this.message = e;
				}else{
					this.sendMsg(1,e+'')
				}
			},
			sendMsg(type ,option){
				let message
				//发送文字信息
				if(type==1){
					let text
					if(option){ text = option; } else { text = this.message };
					if(text.replace(/\s/g,'').length<1) return this.$eltips('不能发送空信息','warning');
					message = this.tim.createTextMessage({
						to: this.toAccount,
						conversationType: 'C2C',
						payload: {
							text: text,
						},
						cloudCustomData:this.positionId.toString()
					});
				}
				
				//发送图片
				if (type == 2) {
					message = this.tim.createImageMessage({
						to: this.toAccount,
						conversationType: 'C2C',
						payload: { file: option },
						cloudCustomData:this.positionId.toString()
					});
				}
				
				//发送位置
				if (type == 3) {
					message = this.tim.createLocationMessage({
						to: this.toAccount,
						conversationType: 'C2C',
						payload: { 
							description: JSON.stringify({name:option.name,address:option.address}),
							longitude: option.lng, // 经度
							latitude: option.lat // 纬度
						},
						cloudCustomData:this.positionId.toString()
					});
				}
				
				//职位推送
				if (type == 4) {
					message = this.tim.createCustomMessage({
						to: this.toAccount,
						conversationType: 'C2C',
						payload: { 
							data: JSON.stringify(option),
							description: 'pushJob',
							extension: ''
						},
						cloudCustomData:this.positionId.toString()
					});
				}
				
				this.$store.commit('sendMessage', message);
				if (type==1) this.message = '';
				this.tim.sendMessage(message).then().catch(err => {
					if(err.code==80001){
						this.$eltips('发送失败，内容包含有敏感词汇','error')
					}else if(err.code==60020){
						this.$eltips('系统错误，请联系管理员','error')
					}else{
						console.log(err)
						this.$eltips('发送失败','error')
					}
				})
			},
			initMap() {
				AMapLoader.load({
					"key": this.mapKey,
					"plugins": [],
				}).then((AMap) => {
					// 初始化地图
					this.mapContent = new AMap.Map('TMap', {
						viewMode: "2D", //  是否为3D地图模式
						zoom: 13, // 初始化地图级别
						resizeEnable: true
					});
				}).catch(e => {
					console.log('地图加载出错-----消息界面',e);
				});
			},
			openTMap(lat,lng,address){
				if(this.mapMarker) this.mapContent.remove(this.mapMarker);
				let position = new AMap.LngLat(lng,lat)
				this.mapContent.setCenter(position,true,)
				this.mapMarker =  new AMap.Marker({
					position: position, 
					label:{
					  content:JSON.parse(address).address,
					  direction:'top'
					}
				});
				this.mapContent.add(this.mapMarker)
				this.mapShow = true
			},
			playAudio(item){
				if( this.AUDIO!= null ) {
					if(this.playAudioId==item.ID){
						if(this.audioStatus){
							this.AUDIO.pause();
						}else{
							this.AUDIO.play();
						}
						return
					}else{
						this.AUDIO.pause();
						this.AUDIO = null;
						this.audioStatus = false
						this.playAudioId = ''
					}
				}
				this.AUDIO= new Audio(item.payload.url);
				this.AUDIO.addEventListener('ended',()=>{
					this.audioStatus = false
					this.playAudioId=null;
				})
				this.AUDIO.addEventListener('pause',()=>{
					this.audioStatus = false
				})
				this.AUDIO.addEventListener('playing',()=>{
					this.audioStatus = true
				})
				this.playAudioId=item.ID;
				this.AUDIO.play();
			},
			async toChat(conversationID){
				if(conversationID==this.currentConversationID) return;
				this.positionDetail = null
				this.positionId = ''
				if(this.AUDIO) this.AUDIO.pause(),this.playAudioId = '';
				this.dataShow = false
				this.is_resume = false
				await this.$store.dispatch('checkoutConversation', {conversationID:conversationID})
				if(this.storePositionId){
					this.positionId = this.storePositionId
					this.getPosition()
				}
				this.tim.getUserProfile({userIDList:[this.toAccount]}).then(res=>{
					this.chatUserinfo = res.data[0]
					this.$nextTick(()=>{
						const historybox = this.$refs.historybox
						historybox.scrollTo({top:historybox.scrollHeight})
					})
				})
			},
			getPosition(){
				this.$axios.get('/api/client/Home/getPositionDetails',{params:{id:this.positionId}}).then(res=>{
					if(res.code==200){
						console.log('position',res.data)
						this.positionDetail = res.data
						this.$nextTick(()=>{
							const historybox = this.$refs.historybox
							historybox.scrollTo({top:historybox.scrollHeight})
						})
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.communication {
		position: relative;
		overflow: hidden;

		.communicationCon {
			display: flex;
			align-items: center;
			padding: 24px 0;
			box-sizing: border-box;
			height: calc(100vh - 56px);
			width: 1200px;
			position: relative;
			z-index: 2;
			margin: 0 auto;

			::-webkit-scrollbar {
				width: 4px;
				/*  设置纵轴（y轴）轴滚动条 */
				height: 8px;
				/*  设置横轴（x轴）轴滚动条 */
			}
			/* 滚动条滑块（里面小方块） */
			::-webkit-scrollbar-thumb {
				border-radius: 10px;
				background: rgba(66, 66, 66, 0.1);
			}
			/* 滚动条轨道 */
			::-webkit-scrollbar-track {
				background: rgba(0, 0, 0, 0.1);
				border-radius: 10px;
				margin: 8px 0;
			}
		}
		
		.conversationList {
			height: 100%;
			box-sizing: border-box;
			background-color: #fff;
			border-radius: 16px;
			flex: 0 0 405px;
			width: 405px;
			overflow-y: auto;
			margin-right: 8px;
			.li {
				border-radius: 16px;
				padding: 16px 22px;
				display: flex;
				align-items: center;
				cursor: pointer;
				.avatarbox{
					flex: 0 0 46px;
					margin-right: 12px;
					position: relative;
					.avatar {
						width: 46px;
						height: 46px;
						border-radius: 50%;
					}
					.unreadCount {
						line-height: 17px;
						height: 17px;
						padding: 0 5px;
						text-align: center;
						background-color: #FF4444;
						font-size: 11px;
						color: #FFFFFF;
						position: absolute;
						right: -6px;
						top: 0;
						border-radius: 17px;
					}
				}
		
				.info {
					flex: 1;
					height: 46px;
					overflow: hidden;
					.top {
						.topL {
							display: flex;
							margin-right: 12px;
							.name {
								color: #151515;
								font-size: 14px;
								margin-right: 12px;
							}
							.cor {
								font-size: 13px;
								color: #858585;
							}
						}
						.time {
							float: right;
							max-width: 145px;
							vertical-align: middle;
							color: #B8B8B8;
							font-size: 13px;
							text-align: right;
						}
					}
		
					.mess {
						// line-height: 1;
						margin-top: 8px;
						color: #636363;
						font-size: 14px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}	
			}
			.select {
				background: linear-gradient(94deg, #E3D6FF 0%, #FFFFFF 100%);
			}
		}
	}
	
	.chatFrame{
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		border-radius: 16px;
		overflow: hidden;
	}
	.whiteback{
		background: #FFF;
	}
	
	.chatHistory{
		flex: 1;
		width: 100%;
		padding: 16px 16px;
		box-sizing: border-box;
		background-color: #Fff;
		border-radius: 16px;
		margin-bottom: 8px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		.info{
			display: flex;
			align-items: center;
			color: #5E5E5E;
			margin-bottom: 18px;
			.name{
				font-size: 16px;
				margin-right: 16px;
			}
			.corName{
				font-size: 13px;
			}
		}
	    .position{
			margin-bottom: 22px;
			padding: 16px;
			background: rgba(81, 161, 144, .1);
			border-radius: 8px;
			.title{
				font-size: 18px;
				color: #151515;
				display: inline-block;
				vertical-align: middle;
				cursor: pointer;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				max-width: 400px;
				&:hover{
					color: #51a190;
				}
			}
			.pay{
				color: #FF6666;
				font-size: 20px;
				margin: 0 18px;
				font-weight: bold;
				display: inline-block;
				vertical-align: middle;
				cursor: pointer;
			}
			.address{
				color: #5E5E5E;
				font-size: 14px;
				display: inline-block;
				vertical-align: middle;
				cursor: pointer;
			}
		}
		.filter{
			filter: gray;
			filter: grayscale(.95);
			-webkit-filter: grayscale(.95);
		}
	}
	
	.history{
		flex: 1;
		overflow-y: auto;
		.list{
			margin-bottom: 20px;
			overflow: hidden;
			&:first-child{
				margin-top: 0;
			}
			.avatarbox{
				width: 36px;
				margin-right: 10px;
				.avatar{
					width: 36px;
					height: 36px;
					border-radius: 50%;
				}
			}
			.msgbox{
				max-width: 600px;
				position: relative;
				background-color: rgba(81, 161, 144, .6);
				color: #FFFFFF;
				border-radius: 6px;
				padding:9px;
				margin-top: 6px;
				.text{
					white-space: pre-line;
					font-size: 14px;
				}
				.imgbox{
					cursor: pointer;
					.img{
						width: 150px;
						height: 150px;
					}
				}
				.audio{
					display: flex;
					align-items: center;
					line-height: 1;
					.icon{
						color: #FFFFFF;
						font-size: 16px;
						margin-right: 4px;
						font-weight: bold;
					}
				}
				.play{
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					// 模拟录音音效动画
					@keyframes playAnimation {
						0% {background-position: 20%  0%;}
						60% {background-position: 20%  0%;}
						100% {background-position: 20%  0%;}
					}
					.icon{
						background-image:#51A190; 
						background-size:50% 100%;
						animation: playAnimation 1.2s ease-in-out -.2s infinite normal;
						-webkit-background-clip:text; 
						// -webkit-text-fill-color:transparent; 
						font-size: 16px;
					}
				}
				.locationBox{
					width: 250px;
					cursor: pointer;
					display: flex;
					align-items: center;
					.icon{
						font-size: 36px;
						margin-right: 6px;
						color: #51a190;
					}
					.locationtext{
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-size: 13px;
					}
					.map{
						margin-top: 14px;
						width: 200px;
						height: 100px;
					}
				}
			}
		}
		
		.left{
			.avatarbox{
				float: left;
				margin-right: 10px;
			}
			.msgbox{
				float: left;
				background: #EEE;
				color: #333333;
				.audio{
					.icon{
						color: #333;
					}
				}
			}
			.msgIcon{
				float: left;
			}
		}
		.right{
			.avatarbox{
				float: right;
				margin-left: 10px;
			}
			.msgbox{
				float: right;
				.locationBox{
					.icon{
						color: #FFFFFF;
					}
				}
			}
			.msgIcon{
				float: right;
			}
		}
	}
	
	.databox{
		position: relative;
		padding-top: 40px;
		overflow: hidden;
		.dataTitle{
			box-sizing: border-box;
			height: 40px;
			width: 100%;
			position: absolute;
			left: 0;
			top: 0;
			background: #FFF;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
			// box-shadow: 4px 2px 10px rgba(0, 0, 0, 0.3);
			border-bottom: 1px solid #e3e3e3;
		}
		.formbox{
			display: flex;
			margin-top: 18px;
			.label{
				flex: 0 0 6em;
				font-size: 15px;
			}
		}
		.infobox{
			height: calc(100% - 16px);
			overflow-y: auto;
			margin-top: 16px;
			.userinfobox{
				display: flex;
				align-items: center;
				.avatarbox{
					width: 46px;
					height: 46px;
					position: relative;
					margin-right: 18px;
					.avatar{
						width: 46px;
						height: 46px;
						border-radius: 50%;
						display: block;
					}
				}
				.textbox{
					height: 46px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.name{
						font-size: 16px;
						font-weight: bold;
						span{
							font-weight: normal;
							display: inline;
							font-size: 14px;
							margin-left: 14px;
						}
					}
					.text{
						font-size: 14px;
					}
				}
			}
			.evaluationbox{
				margin-top: 18px;
				font-size: 14px;
				background: #F5F5F5;
				padding: 14px;
				border-radius: 8px;
				white-space: pre-line; 
			}
			.explist{
				flex: 1;
				.nodata{
					font-size: 14px;
					color: #666;
				}
				.list{
					margin-bottom: 12px;
					&:last-child{
						margin-bottom: 0;
					}
					.topbox{
						display: flex;
						align-items: flex-start;
						margin-bottom: 8px;
						.left{
							flex: 1;
							font-size: 14px;
							// font-weight: bold;
						}
						.right{
							text-align: right;
							flex: 0 0 130rpx;
							font-size: 14px;
							color: #5E5E5E;
						}
					}
					.textbox{
						margin-bottom: 8px;
						color: #5E5E5E;
						font-size: 14px;
						&:last-child{
							margin-bottom: 0;
						}
						text{
							&::after{
								content: '·';
								margin: 0 4px;
							}
							&:last-child::after{
								content: '';
								margin: 0;
							}
						}
					}
				}
			}
		}
		.positionbox{
			height: calc(100% - 16px);
			overflow-y: auto;
			margin-top: 16px;
			.tagbox {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.tag{
					margin-right: 8px;
					margin-bottom: 8px;
				}
			}
			.descbox{
				color: #5E5E5E;
				font-size: 15px;
				// white-space: pre-line;
				white-space:pre-wrap;
				.companyName{
					cursor: pointer;
					color: #51A190;
				}
			}
		}
	}
	
	.mapBody{
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 999;
		left: -100%;
		top: 0;
		background: rgba(0, 0, 0, 0.4);
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
	}
	.mapbox{
		background: #FFFFFF;
		padding:18px;
		border-radius: 4px;
		.titlebox{
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 18px;
			font-size: 14px;
			.bold{
				font-weight: bold;
			}
			.icon{
				font-size: 18px;
				cursor: pointer;
			}
		}
	}
	.mapShow{
		left: 0;
		opacity: 1;
	}
	
	.chatInput{
		flex: 0 0 auto;
		background-color: #Fff;
		border-radius: 16px;
		width: 100%;
		height: 200px;
		padding:0 16px;
		box-sizing: border-box;
		position: relative;
		.menubox{
			width: 100%;
			height: 40px;
			border-bottom: 1px solid #ebebeb;
			display: flex;
			align-items: center;
			padding: 0 12px;
			.iconbox{
				font-size: 22px;
				margin-right: 22px;
				position: relative;
				height: auto;
				display: flex;
				align-items: center;
				cursor: default;
				color: #666666;
				&:hover{
					color: #51a190;
				}
				.icon{
					margin-right: 2px;
				}
				span{
					font-size: 14px;
				}
				.uploadInput{
					width: 0;
					height: 0;
					opacity: 0;
				}
			}
		}
		.inputArea{
			width: 100%;
			padding: 12px;
			box-sizing: border-box;
			height: 100px;
			border:none;
			font-size: 14px;
			outline: none;/*边线不显示*/
			resize: none;/*禁止拉伸*/
			appearance:none;
		}
		.btnbox{
			width: 100%;
			height: 40px;
			padding: 0 12px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			box-sizing: border-box;
			font-size: 14px;
			color: #aaa;
		}
	}

	.setMsgBox{
		max-height: 600px;
		overflow-y: auto;
		.listbox{
			border-top: 1px solid #e8e9eb;
			.nodata{
				padding: 24px 0;
				text-align: center;
				color: #999999;
			}
			.list{
				padding: 12px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #e8e9eb;
				&:last-child{
					border-bottom: none;
				}
				.text{
					flex: 1;
					font-size: 13px;
				}
				.delIcon{
					flex: 0 0 20px;
					font-size: 18px;
					text-align: right;
					color: #999999;
				}
			}
		}
		.btnbox{
			padding-top: 12px;
			display: flex;
			align-items: center;
			border-top: 1px solid #e8e9eb;
			.tips{
				font-size: 12px;
				color: #999999;
				margin-left: 12px;
			}
		}
	}

	.usedBox{
		.titlebox{
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 12px;
			border-bottom: 1px solid #e8e9eb;
			.btn{
				cursor: pointer;
				color: #51a190;
			}
		}
		.listbox{
			.nodata{
				text-align: center;
				padding: 12px;
				color: #999999;
				span{
					color: #51a190;
					cursor: pointer;
				}
			}
			.box{
				.textbox{
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding:12px 6px;
					font-size: 13px;
					cursor: pointer;
					&:hover{
						background: #f1f6ff;
						.btn{
							opacity: 1;
						}
					}
					.text{
						flex: 1;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.btn{
						flex: 0 0 40px;
						font-size: 13px;
						opacity: 0;
						color: #51a190;
					}
				}
			}
		}
	}
</style>